export default __webpack_public_path__ + "static/media/head03_zh_cn_pc@2x.4f4443b6.png";